import React from 'react';

const Step_Loading_GeneratingEvaluation = ({ data, onDataChange, evaluationData, onRefresh, onClose }) => {
  
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  // Determine what's being generated based on evaluation status
  const getGenerationMessage = () => {
    const status = evaluationData?.status;
    if (status === 'evs_generating_questionnaire') {
      return {
        title: 'Questionnaire',
        description: 'The questionnaire is currently being generated based on your confirmed criteria.'
      };
    } else if (status === 'evs_generating_challenge') {
      return {
        title: 'Challenge',
        description: 'The challenge is currently being generated based on your confirmed criteria.'
      };
    } else {
      return {
        title: 'Evaluation',
        description: 'The evaluation is currently being generated based on your confirmed criteria.'
      };
    }
  };

  const { title, description } = getGenerationMessage();

  return (
    <div className="h-full flex flex-col">
      {/* Main Content Area - Light Blue Background */}
      <div className="flex-1 flex items-center justify-center p-8" style={{ backgroundColor: 'var(--color-brand-blue-light)' }}>
        <div className="text-center max-w-md">
          <div className="mb-6">
            {/* AI-inspired neural network animation */}
            <div className="relative w-20 h-20 mx-auto mb-4">
              {/* Central node */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full animate-pulse"></div>
              
              {/* Surrounding nodes with staggered animations */}
              <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
              <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
              <div className="absolute top-1/2 left-2 transform -translate-y-1/2 w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.6s'}}></div>
              <div className="absolute top-1/2 right-2 transform -translate-y-1/2 w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.8s'}}></div>
              
              {/* Corner nodes */}
              <div className="absolute top-3 left-3 w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
              <div className="absolute top-3 right-3 w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse" style={{animationDelay: '1.2s'}}></div>
              <div className="absolute bottom-3 left-3 w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse" style={{animationDelay: '1.4s'}}></div>
              <div className="absolute bottom-3 right-3 w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse" style={{animationDelay: '1.6s'}}></div>
              
              {/* Connection lines (subtle) */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-0.5 bg-blue-300 opacity-30 animate-pulse" style={{animationDelay: '0.5s'}}></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-0.5 h-16 bg-blue-300 opacity-30 animate-pulse" style={{animationDelay: '0.7s'}}></div>
            </div>
          </div>
          
          <p className="text-3xl text-gray-800 mb-6">
            Assembling <span className="font-bold">{title}</span> ...
          </p>
          
          <p className="text-xl text-gray-700 mb-8">
            {description}
          </p>
          
          <p className="text-base text-gray-600 mb-8">
            Creating the evaluation takes ~10 min.
          </p>
          
          <div className="flex items-center justify-center gap-4 mb-12">
            <button
              onClick={handleRefresh}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 rounded transition-colors"
            >
              Check Status
            </button>
            
            <button
              onClick={handleClose}
              className="border border-blue-600 text-blue-600 hover:bg-blue-50 font-medium px-6 py-2 rounded transition-colors"
            >
              Close
            </button>
          </div>
          
          {/* Note callout */}
          <div className="bg-blue-50 border border-blue-300 rounded-lg p-4 max-w-lg mx-auto">
            <p className="text-base text-blue-700 text-center">
              The Evaluation will be available in the Talent or Candidate Evaluation list once completed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step_Loading_GeneratingEvaluation;
